import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SCUIGeneralModal, SCUISnackbar } from '../../../../atomic/molecules';
import { FormControl, Grid, IconButton, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { SCUIButton } from '../../../../atomic/atoms';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { RuleServiceCommand } from '../../../../services/command';
import { Operators, RuleTenant } from '../../RuleService.const';
import { getSnackbarValue, validateRuleTemplate } from '../../helper/RuleModal.helper';
import { enumSnackbarStatusType } from '../../../../types/enums';

export const SCUIRuleTemplateModal: FC<{
    open: boolean;
    tenant: any;
    onClose: any;
    criteriaTypes: any;
}> = ({ open, tenant, onClose, criteriaTypes }) => {
    const { t } = useTranslation();
    const operators = Operators();
    const [modalState, setModalState] = useState({
        Id: '',
        Name: '',
        Tenant: tenant,
        criteriaTypes: [] as any,
    });
    const [snackbar, setSnackbar] = React.useState({
        show: false,
        message: '',
        status: enumSnackbarStatusType.success,
    });
    const save = async (modalState: any) => {
        let currentPayload = modalState;
        let validation = validateRuleTemplate(currentPayload);
        if (!validation.isValid) {
            setSnackbar({
                show: true,
                message: validation.messages.join(', '),
                status: enumSnackbarStatusType.danger,
            });
            return;
        }
        if (currentPayload) {
            let response = await RuleServiceCommand.CreateRuleTemplate({
                RuleTemplate: currentPayload,
            });
            // eslint-disable-next-line no-empty-pattern
            let snackBarSettings = ({} = getSnackbarValue(response));
            onClose(snackBarSettings);
        }
    };

    const updateChildItem = (value: any, index: number, key: any) => {
        let criteriaTypes = modalState.criteriaTypes;
        criteriaTypes[index][key] = value;
        setModalState((prevState) => ({
            ...prevState,
            criteriaTypes: criteriaTypes,
        }));
    };
    const removeChildItem = (index: number) => {
        modalState.criteriaTypes.splice(index, 1);
        setModalState((prevState) => ({
            ...prevState,
            criteriaTypes: modalState.criteriaTypes,
        }));
    };
    const addItemToCriteriaTypeValue = () => {
        let value = modalState.criteriaTypes;
        value.push({ CriteriaTypeId: '', Operator: '' });
        setModalState((prevState) => ({
            ...prevState,
            criteriaTypes: value,
        }));
    };
    return (
        <SCUIGeneralModal
            width={'xs'}
            open={open}
            onClose={onClose}
            title={t(`ruleManagement.modal.ruleTemplate.title`)}
            buttonText={t('general.save')}
        >
            <Grid container sx={{ padding: '2rem' }} style={{ display: 'flex' }}>
                <FormControl fullWidth>
                    <TextField
                        required={true}
                        sx={{ paddingBottom: '1rem' }}
                        value={modalState.Name}
                        label={t(`ruleManagement.fields.ruleTemplate.name.name`)}
                        disabled={false}
                        multiline
                        onChange={(event: any) => {
                            setModalState((prevState) => ({
                                ...prevState,
                                Name: event.target.value,
                            }));
                        }}
                        fullWidth
                    />
                </FormControl>
                <FormControl fullWidth>
                    <TextField
                        required={true}
                        sx={{ paddingBottom: '1rem' }}
                        value={RuleTenant[tenant as keyof typeof RuleTenant]}
                        label={'Tenant'}
                        disabled={true}
                        multiline
                        fullWidth
                    />
                </FormControl>

                {modalState.criteriaTypes && (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div style={{ width: 100 }}>
                            <IconButton
                                size="small"
                                sx={{ paddingTop: '1rem' }}
                                onClick={() => {
                                    addItemToCriteriaTypeValue();
                                }}
                            >
                                <AddIcon />
                                {t('general.add')}
                            </IconButton>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            {modalState.criteriaTypes &&
                                modalState.criteriaTypes.map((item: any, key: number) => (
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'start',
                                        }}
                                        key={key}
                                    >
                                        <FormControl style={{ width: 150, margin: '20px' }}>
                                            <InputLabel id={'CriteriaType' + key}>
                                                {t(`ruleManagement.fields.ruleTemplate.criteriaType.name`)}
                                            </InputLabel>
                                            <Select
                                                labelId={'CriteriaType' + key}
                                                id={'CriteriaType' + key}
                                                size="medium"
                                                onChange={(event: any) => {
                                                    updateChildItem(event.target.value, key, 'CriteriaTypeId');
                                                }}
                                                label={t(`ruleManagement.fields.ruleTemplate.criteriaType.name`)}
                                            >
                                                {criteriaTypes &&
                                                    criteriaTypes.map((criteriaType: any, index: number) => (
                                                        <MenuItem
                                                            key={index}
                                                            id={criteriaType.id}
                                                            value={criteriaType.id}
                                                        >
                                                            {criteriaType.name}
                                                        </MenuItem>
                                                    ))}
                                            </Select>
                                        </FormControl>
                                        <FormControl style={{ width: 150, margin: '20px' }}>
                                            <InputLabel id={'Operator'}>
                                                {t(`ruleManagement.fields.ruleTemplate.operator.name`)}
                                            </InputLabel>
                                            <Select
                                                labelId={'Operator'}
                                                id={'Operator'}
                                                onChange={(event: any) => {
                                                    updateChildItem(parseInt(event.target.value), key, 'Operator');
                                                }}
                                                size="medium"
                                                label={t(`ruleManagement.fields.ruleTemplate.operator.name`)}
                                            >
                                                {operators &&
                                                    operators.map((operator: any, index: any) => (
                                                        <MenuItem
                                                            key={index}
                                                            id={operator.value}
                                                            value={operator.value}
                                                        >
                                                            {operator.label}
                                                        </MenuItem>
                                                    ))}
                                            </Select>
                                        </FormControl>
                                        <IconButton
                                            size="small"
                                            onClick={() => {
                                                removeChildItem(key);
                                            }}
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                    </div>
                                ))}
                        </div>
                    </div>
                )}
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row-reverse',
                        width: '100%',
                    }}
                >
                    <div className="m-l-16">
                        <SCUIButton
                            type="primary"
                            sizeType="fixed"
                            text={t('general.save')}
                            onClick={() => {
                                save(modalState);
                            }}
                            size="s"
                        ></SCUIButton>
                    </div>

                    <SCUIButton
                        type="secondary"
                        sizeType="fixed"
                        text={t('general.cancel')}
                        size="s"
                        onClick={onClose}
                    ></SCUIButton>
                </div>
            </Grid>
            <SCUISnackbar
                show={snackbar.show}
                messageText={snackbar.message}
                status={snackbar.status}
                autoHideDuration={2000}
                onClose={() => {
                    setSnackbar({
                        show: false,
                        message: '',
                        status: enumSnackbarStatusType.success,
                    });
                }}
            />
        </SCUIGeneralModal>
    );
};
